module.exports = __webpack_public_path__ + "static/media/ACM.c389994d.jpg";